import type { FaireProductEntity } from "../../entity_types/product";

export const p_6uudfgsqjp: FaireProductEntity = {
  token: "p_6uudfgsqjp",
  type: "product",
  name: "Green Tree Taper Candles, Set of 2 - Christmas Decor",
  brandToken: "b_1b0f6a45",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/2e3cdba14da48d1c461ce601dbd55c7547682bb92ef2bb7b8c76e4ec3620f47d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/45f6bbca86c2d94af844822fad3e465e992cf26d89ae75e9b51f38b29ab33307.png",
    "https://cdn.faire.com/fastly/ae95f77876064cb503d3e112a4e264eac793dbdafdca7b33c2bb882ec272ed74.jpeg",
    "https://cdn.faire.com/fastly/eee7553f9e618d586796c16e7fb73dbfa9004b70d9fbf92bbee9bc4a7aae752f.png",
  ],
  priceDollars: 15,
  description:
    'Add festive charm to your holiday decorations with our Tree Shaped Taper Candle Set. These non-toxic, green taper candles are beautifully crafted in a classic Christmas tree shape, perfect for holiday candles displays on dining tables, mantels, and entryways. With over 6 hours of burn time, they’re an elegant, seasonal accent your customers will love.\n\nPair these taper candles with our black and gold taper candle holder sets, sold separately.\n\nITEM DETAILS:\n• Set of 2 \n• 10" unscented candles \n• Design: Green Tree \n• Non-metal, non-toxic, lead free \n• Gluten Free, phthalate free \n• 100% cotton wick - lead and zinc free \n• Self-fitted to position into candle holders \n• 6.5+ hours burn time\n• Packaging Dimensions: 10.63” HT x 2.63” W x 1.25” D\n• Designed in the USA, Imported\n• Style No. TC003\n\nCATEGORIES:\nChristmas 2026, Holiday decor, holiday accessories, candle sticks, winter decor, Christmas candles, holiday accessories',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:24.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
